import { createSelector } from "@reduxjs/toolkit";
import {
  IAccommodationRoomType,
  IAccommodationRoomWithBlock,
} from "Bands/types";
import { API_ENDPOINTS } from "shared/constants";

import { IDataKeys } from "shared/types";
import { buildData } from ".";
import { dataSelector } from "./helpers";

export const customAccommodationRoomTypesSelectorCreator = (blockId: string) =>
  createSelector(dataSelector, (data) => {
    const roomTypes = (buildData(
      data as any,
      IDataKeys.eventAccommodationRoomType
    ) || []) as IAccommodationRoomWithBlock[];

    return roomTypes
      .filter(
        ({ accommodationBlock }) =>
          accommodationBlock.id ===
          API_ENDPOINTS.EVENT_ACCOMMODATION_BLOCK(blockId)
      )
      .map(
        (roomType) =>
          ({
            ...roomType,
            accommodationBlock: roomType.accommodationBlock.id,
          } as IAccommodationRoomType)
      );
  });
